import React, {useState, useRef, useEffect} from 'react';
import ActionItemAssign from './ActionItemAssign.mjs';
import './ActionItemForm.css';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function ActionItemForm() 
{
    const { action_item, app_user, action_item_display_refresh, action_item_list_display, 
            setUserChangedActionItem, setActionItemDisplayRefresh,
            setActionItemShortListRefresh, setActionItemLongListRefresh, setActionItemTeamListRefresh,
            setActionItemListLocalRefresh, setSelectedActionItem } = useCTAL(); 

    const [error, setError] = useState();
    const [form_changed_flag, setFormChangedFlag] = useState(false);
    const [action_button_type, setActionButtonType] = useState("btn btn-sm btn-secondary");

    var date_time, due_date;
    if (action_item.DueAt)
    {
        date_time = new Date(action_item.DueAt);
        due_date = date_time.toISOString().split('T')[0];
    }
    else
        due_date = "";

    const refresh_action_item_list = () => { 
        if (DEBUG) console.log(`ActionItemForm****** SETTING User Changed Action-Item to TRUE`);
        setSelectedActionItem(action_item); //Keep this Action Item Detail Displayed
        setUserChangedActionItem(true);
        setActionItemDisplayRefresh(true); //Trigger the Action-Item bulk download in ActionItem.mjs
    }
    
    useEffect(() =>
    {
        setFormChangedFlag(false);
        setActionButtonType("btn btn-sm btn-secondary");

        //input-groups only initialize their defaultValue once, so need to reset form when changing Action-Item
        var myForm = document.getElementById("action-item-form");
        if (myForm) myForm.reset();

        document.getElementById("action-item-progress-status").value = action_item.ProgressStatus;
        document.getElementById("action-item-priority").value = action_item.Priority;

        if (DEBUG) console.log(`ActionItemForm**** - RESET, action-item: ${action_item.Name}, Summary: ${action_item.Summary}, Priority: ${action_item.Priority}`);
    }, [action_item]);

    useEffect(() =>
    {
        if (DEBUG) console.log(`ActionItemForm - form_changed_flag: ${form_changed_flag}`);
        if (!form_changed_flag)
            setActionButtonType("btn btn-sm btn-secondary");
        else
            setActionButtonType("btn btn-sm btn-primary");
    }, [form_changed_flag]);

    const send_action_item_update = (body) => { 
        console.log(`ActionItemForm - Send Action-Item Update, body: ${body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-upd`, { method: "POST", body: body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: body })
        .then(() => refresh_action_item_list())
        .catch(setError);
    }

    const create_action_item_update = () => { 
        if (!form_changed_flag) return;

        var type = "update_action_item";
        var action_item_id     = action_item.ActionItemID;
        var user_id            = app_user.UserID;
        var user_full_name     = app_user.UserFullName;
        var progress_status    = document.getElementById("action-item-progress-status").value;
        var summary            = document.getElementById("action-item-summary").value;
        var desc               = document.getElementById("action-item-desc").value;
        var priority           = document.getElementById("action-item-priority").value;
        var due_date           = document.getElementById("action-item-due-date").value;
        var time_est_hrs       = document.getElementById("action-item-time-est").value;

        var assigned_tags = action_item.TagList.join(", ");
        var tag_name_list = assigned_tags;
        //var tag_name_list      = document.getElementById("action-item-tag-list").value;

        var body = JSON.stringify({type, action_item_id, user_id, user_full_name, progress_status, summary, desc, priority, due_date, time_est_hrs, tag_name_list});

        send_action_item_update(body);

        setFormChangedFlag(false);
    }
    
    const form_changed = () => { 
        setFormChangedFlag(true);
    }

    const assign_prefix = "ActionForm";

    return (
        <>
            <form id="action-item-form" >

                <div class="row mt-1">
                    <div class="col-3 col-md-3 col-lg-3 text-start">  
                        <select id="action-item-progress-status" class="form-select form-select-sm" defaultValue={action_item.ProgressStatus} aria-label="Action Progress Status" onChange={form_changed}>
                            <option value="Not-Started">Not-Started</option>
                            <option value="In-Progress">In-Progress</option>
                            <option value="Blocked">Blocked</option>
                            <option value="Done">Done</option>
                            <option value="Checking">Checking</option>
                            <option value="Verified">Verified</option>
                            <option value="Complete">Complete</option>
                            <option value="Closed">Closed</option>
                        </select>
                    </div>
                    
                    <div class="col-4 col-md-4 col-lg-5 text-start">  
                        <ActionItemAssign action_item={action_item} assign_prefix={assign_prefix} />
                    </div>

                    <div class="col-5 col-md-5 col-lg-4 text-end">  
                        <a id="update-ai-btn" href="#" class={action_button_type} onClick={ () => create_action_item_update() }>Update Action</a>
                    </div>
                </div>

                <div class="input-group mt-1">
                    <span class="input-group-text">Title</span>
                    <textarea id="action-item-summary" class="form-control" defaultValue={action_item.Summary} aria-label="Summary" onChange={form_changed}></textarea>
                </div>

                <div class="form-floating mt-1">
                    <textarea id="action-item-desc" class="form-control" placeholder="Action Description" defaultValue={action_item.Description} onChange={form_changed}></textarea>
                    <label class="select-floating-label" htmlFor="floatingSelect">Action Description</label>
                </div>
                
                <div class="row">
                    <div class="form-floating col-6 col-md-6 col-lg-4 mt-1">
                        <select id="action-item-priority" class="form-select" defaultValue={action_item.Priority} aria-label="Select Action Priority" onChange={form_changed}>
                            <option value="On-Fire">On-Fire</option>
                            <option value="Hot" >Hot</option>
                            <option value="Normal" >Normal</option>
                            <option value="Low" >Low</option>
                        </select>
                        <label class="select-floating-label" htmlFor="action-item-priority">Action Priorty</label>
                    </div>
                    <div class="form-floating col-6 col-md-6 col-lg-4 mt-1">
                        <input id="action-item-due-date" type="date" class="form-control" defaultValue={due_date} aria-label="Due Date" aria-describedby="basic-addon1" onChange={form_changed}/>
                        <label class="select-floating-label" htmlFor="due-date">Due Date</label>
                    </div>

                    <div class="form-floating col-6 col-md-6 col-lg-4 mt-1">
                        <input id="action-item-time-est" type="number" class="form-control" defaultValue={action_item.EstTimeMin} aria-label="Time Estimate" aria-describedby="basic-addon1" onChange={form_changed}/>
                        <label class="select-floating-label" htmlFor="time-estimate">Time Est. (ex. 1.5 hrs)</label>
                    </div>
                </div>

            </form>
       </>
    );
}

/*
    <a id="update-ai-btn" href="#" class={update_ai_state} onClick={ () => create_action_item_update() }>Update Action</a>

    //Sept 18, 2023 - Used to reload full Action Item List, but now just 
    //                updating only the changed Action Item after the bulk fetch in ActionItem.mjs
        switch(action_item_list_display)
        {
            case "team-display":
            case "team-assigned-display":
                setActionItemTeamListRefresh(true);
                break;
            case "user-short-list-display":
                setActionItemShortListRefresh(true);
                break;
            case "user-long-list-display":
                setActionItemLongListRefresh(true);
                break;
            default:
                return;
        }
*/